"use client";
import dynamic from 'next/dynamic';

const Prism=dynamic(()=>import('./bite-prism'),{ssr:false});

export function BiteReportSearchBackdrop(){
  return <div className="bite-report-search__backdrop" aria-hidden="true">
    <div className="bite-report-search__prism"><Prism animationType="rotate" timeScale={0.5} scale={3.6} noise={0} glow={1} height={3.5} baseWidth={5.5} hueShift={0} colorFrequency={1} suspendWhenOffscreen/></div>
  </div>;
}
